'use strict';

const responseTimes = [
  {
    max: 30,
    value: 'instantly'
  },
  {
    max: 90,
    value: 'within an hour'
  },
  {
    max: 720,
    value: 'within several hours'
  },
  {
    value: 'within a day'
  }
];
const responseTime = function () {

  /**
   * Converts average response time to verbal form.
   *
   * @param {Number} minutes Average response time in minutes
   * @returns {String}
   */
  var filter = function (minutes) {
    let result;

    if (angular.isNumber(minutes)) {
      for (let iter = 0; iter < responseTimes.length; iter++) {
        if (!responseTimes[iter].max || minutes <= responseTimes[iter].max) {
          result = responseTimes[iter].value;
          break;
        }
      }
    }

    return result;
  };

  return filter;
};

export default responseTime;



// WEBPACK FOOTER //
// ./app/src/filters/response_time.js